/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApprenticeshipDtoPagedListData } from '../models/ApprenticeshipDtoPagedListData';
import type { ApprenticeshipInput } from '../models/ApprenticeshipInput';
import type { ApprenticeshipModuleDto } from '../models/ApprenticeshipModuleDto';
import type { ApprenticeshipModuleQuestionDto } from '../models/ApprenticeshipModuleQuestionDto';
import type { ApprenticeshipModuleQuestionGroupDto } from '../models/ApprenticeshipModuleQuestionGroupDto';
import type { ModuleDtoPagedListData } from '../models/ModuleDtoPagedListData';
import type { ModuleInput } from '../models/ModuleInput';
import type { ModuleRestoreInput } from '../models/ModuleRestoreInput';
import type { ModulesQuestionDto } from '../models/ModulesQuestionDto';
import type { ModuleStatus } from '../models/ModuleStatus';
import type { ModuleType } from '../models/ModuleType';
import type { QuestionsCommentInput } from '../models/QuestionsCommentInput';
import type { QuestionsJobNumberInput } from '../models/QuestionsJobNumberInput';
import type { QuestionsStatusInput } from '../models/QuestionsStatusInput';
import type { SingleModuleDto } from '../models/SingleModuleDto';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { UpdateModulesQuestionDto } from '../models/UpdateModulesQuestionDto';
import type { UserModuleStatus } from '../models/UserModuleStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApprenticeshipService {

  /**
   * @param employeeName 
   * @param moduleTypeId 
   * @param moduleId 
   * @param showCompleted 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns ApprenticeshipDtoPagedListData Success
   * @throws ApiError
   */
  public static getApiApprenticeship(
employeeName?: string,
moduleTypeId?: number,
moduleId?: number,
showCompleted?: boolean,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<ApprenticeshipDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Apprenticeship',
      query: {
        'EmployeeName': employeeName,
        'ModuleTypeId': moduleTypeId,
        'ModuleId': moduleId,
        'ShowCompleted': showCompleted,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postApiApprenticeship(
requestBody?: ApprenticeshipInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Apprenticeship',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param employeId 
   * @param moduleTypeId 
   * @param showCompleted 
   * @returns ApprenticeshipModuleDto Created
   * @throws ApiError
   */
  public static getApiApprenticeshipModules(
employeId: number,
moduleTypeId?: number,
showCompleted?: boolean,
): CancelablePromise<Array<ApprenticeshipModuleDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Apprenticeship/{employeId}/modules',
      path: {
        'employeId': employeId,
      },
      query: {
        'ModuleTypeId': moduleTypeId,
        'ShowCompleted': showCompleted,
      },
    });
  }

  /**
   * @param employeId 
   * @param moduleId 
   * @returns ApprenticeshipModuleQuestionDto Success
   * @throws ApiError
   */
  public static getApiApprenticeshipModulesQuestions(
employeId: number,
moduleId: number,
): CancelablePromise<Array<ApprenticeshipModuleQuestionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Apprenticeship/{employeId}/modules/{moduleId}/questions',
      path: {
        'employeId': employeId,
        'moduleId': moduleId,
      },
    });
  }

  /**
   * @param employeId 
   * @param moduleId 
   * @param questionId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiApprenticeshipModulesQuestionsApprove(
employeId: number,
moduleId: number,
questionId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Apprenticeship/{employeId}/modules/{moduleId}/questions/{questionId}/approve',
      path: {
        'employeId': employeId,
        'moduleId': moduleId,
        'questionId': questionId,
      },
    });
  }

  /**
   * @param employeId 
   * @param moduleId 
   * @param questionId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiApprenticeshipModulesQuestionsStatus(
employeId: number,
moduleId: number,
questionId: number,
requestBody?: QuestionsStatusInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Apprenticeship/{employeId}/modules/{moduleId}/questions/{questionId}/status',
      path: {
        'employeId': employeId,
        'moduleId': moduleId,
        'questionId': questionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param employeId 
   * @param moduleId 
   * @param questionId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiApprenticeshipModulesQuestionsComment(
employeId: number,
moduleId: number,
questionId: number,
requestBody?: QuestionsCommentInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Apprenticeship/{employeId}/modules/{moduleId}/questions/{questionId}/comment',
      path: {
        'employeId': employeId,
        'moduleId': moduleId,
        'questionId': questionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param employeeId 
   * @param moduleId 
   * @param questionId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiApprenticeshipModulesQuestionsJobNumber(
employeeId: number,
moduleId: number,
questionId: number,
requestBody?: QuestionsJobNumberInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Apprenticeship/{employeeId}/modules/{moduleId}/questions/{questionId}/job-number',
      path: {
        'employeeId': employeeId,
        'moduleId': moduleId,
        'questionId': questionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param employeeId 
   * @param moduleId 
   * @param questionId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteApiApprenticeshipModulesQuestionsJobNumber(
employeeId: number,
moduleId: number,
questionId: number,
requestBody?: QuestionsJobNumberInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Apprenticeship/{employeeId}/modules/{moduleId}/questions/{questionId}/job-number',
      path: {
        'employeeId': employeeId,
        'moduleId': moduleId,
        'questionId': questionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param employeId 
   * @param status
 *
 * 0 = Active
 *
 * 1 = Inactive
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiApprenticeshipModules(
employeId: number,
status: UserModuleStatus,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Apprenticeship/{employeId}/modules/{status}',
      path: {
        'employeId': employeId,
        'status': status,
      },
    });
  }

  /**
   * @param moduleName 
   * @param moduleType 
   * @param status
 *
 * 1 = Active
 *
 * 2 = Removed
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns ModuleDtoPagedListData Success
   * @throws ApiError
   */
  public static getApiApprenticeshipModules1(
moduleName?: string,
moduleType?: number,
status?: ModuleStatus,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<ModuleDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Apprenticeship/modules',
      query: {
        'ModuleName': moduleName,
        'ModuleType': moduleType,
        'Status': status,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postApiApprenticeshipModules(
requestBody?: ModuleInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Apprenticeship/modules',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns SingleModuleDto Success
   * @throws ApiError
   */
  public static getApiApprenticeshipModule(
id: number,
): CancelablePromise<SingleModuleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Apprenticeship/module/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiApprenticeshipModule(
id: number,
formData?: Record<string, any> | undefined,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Apprenticeship/module/{id}',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param formData 
   * @returns ModulesQuestionDto Success
   * @throws ApiError
   */
  public static postApiApprenticeshipModulesParse(
formData?: {
file?: Blob;
},
): CancelablePromise<Array<ModulesQuestionDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Apprenticeship/modules/parse',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteApiApprenticeshipModules(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Apprenticeship/modules/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiApprenticeshipModulesRestore(
id: number,
requestBody?: ModuleRestoreInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Apprenticeship/modules/{id}/restore',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
